export const toggleSelection = <T extends { id: number }>(selected: T[], row: T): T[] => {
  const exists = selected.some((r) => r.id === row.id);
  return exists ? selected.filter((r) => r.id !== row.id) : [...selected, row];
};

export const selectAll = <T>(rows: T[]): T[] => {
  return rows.slice();
};

export const deselectAll = <T>(): T[] => {
  return [];
};


